import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const AudioSearchSectionContainer = styled.div<{
  $hasSearchResult: boolean
  $hasNotSearchValue: boolean
}>`
  height: ${props => (props.$hasSearchResult ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  padding-bottom: ${props => (props.$hasNotSearchValue ? '16px' : 'auto')};
  width: 100%;
`

export const AudioSearchInputContainer = styled.div`
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding: 0;
  }

  input {
    &:hover {
      box-shadow: rgba(56, 125, 255, 0.16) 0px 0px 0px 1px;
      border: 1px solid border rgba(154, 166, 200, 1);
    }
  }
`
